<div [class]="positionClasses" aria-live="polite" aria-atomic="true">
  @for (toast of toastService.toasts; track toast.id) {
    <div [class]="toastAlertClass(toast.variant)" [ngClass]="toast.className">
      <div class="flex w-full items-start gap-3">
        <div class="flex-1 min-w-0">
          @if (showTitle && toast.title) {
            <div class="font-semibold leading-tight">{{ toast.title }}</div>
          }
          <!-- Content: either consumer projects custom markup (via ng-content),
               or provide plain text via service. For service-based toasts,
               we render message. -->
          <div class="whitespace-pre-line break-words">{{ toast.message }}</div>
        </div>

        @if (toast.closable) {
          <button type="button" class="btn btn-ghost btn-sm" (click)="dismiss(toast.id)" aria-label="Close toast">
            ✕
          </button>
        }
      </div>
    </div>
  }

  <!-- Optional: allow page-local custom toast markup in same container (ng-content)
       for cases where you want full control and manage visibility yourself. -->
  <ng-content></ng-content>
</div>

